<template>
  <tooltip :text="text" :allowHTML="true">
    <span class="label label-warning" @hover.prevent="">
      <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
    </span>
  </tooltip>
</template>

<script>
export default {
  props: {
    failedValidations: Array,
  },
  computed: {
    text() {
      let html = '<ul class="p-sm p-b-none">';

      _.forEach(this.failedValidations, (validation) => {
        html += '<li>' + validation.failed_message + '</li>';
      });

      html += '</ul>';

      return html;
    }
  }
}
</script>